import tags from "../../../components/tags";
import text from "./text";
import status from "../../../components/responses/statusTokens";

export default {
  "Authorization Code Grant: Renewing an access token with refresh token": {
    post: {
      tags: [tags.accessTokens],
      summary: "Get token for administration tasks - Client Credentials Grant",
      description: `
    POST /oauth/access-token
${text.description.summary}
##  Renewing an access token with refresh token

The access token has a limited validity. To refresh it, use refresh_token. To renew the access token, the client sends POST to the authorization server address with following parameters. 

${text.description.contentFormat}

${text.description.clientSecretNote}
`,
      requestBody: {
        required: true,
        content: {
          "application/json": {
            schema: {
              type: "object",
              properties: {
                grant_type: {
                  $ref: "#/components/requestBodies/grantTypeRefresh"
                },
                refresh_token: {
                  $ref: "#/components/requestBodies/refreshToken"
                },
                client_id: {
                  $ref: "#/components/requestBodies/clientId"
                },
                client_secret: {
                  $ref: "#/components/requestBodies/clientSecret"
                }
              }
            }
          }
        }
      },
      responses: {
        ...status,
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  token_type: {
                    $ref: "#components/schemas/tokenType"
                  },
                  expires_in: {
                    $ref: "#components/schemas/expiresIn"
                  },
                  access_token: {
                    $ref: "#components/schemas/accessToken"
                  },
                  refresh_token: {
                    $ref: "#components/schemas/refreshToken"
                  }
                }
              }
            }
          }
        }
      },
      security: []
    }
  }
};
